module.exports = __webpack_public_path__ + "e18ee228c54bb3fe9e447eb142d53688.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_2_tri.mp3
 ** module id = 173
 ** module chunks = 0
 **/